import { Player, Team } from "./Index";
import { Model } from "./Model";

export interface HalfTimeDraw extends Model {
	htDrawFirst: number;
	htDrawFirstPrize: number;
	htDrawSecond: number;
	htDrawSecondPrize: number;
	htDrawThird: number;
	htDrawThirdPrize: number;
	/** Who backs the draw, where anybody does. */
	sponsorName?: string | null;
	sponsorImage?: string | null;
}

export class HalfTimeDraw implements HalfTimeDraw {

	constructor(data?: Partial<HalfTimeDraw>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}